import { render, staticRenderFns } from "./localeSwitcher.vue?vue&type=template&id=b6416106&scoped=true"
import script from "./localeSwitcher.vue?vue&type=script&lang=js"
export * from "./localeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./localeSwitcher.vue?vue&type=style&index=0&id=b6416106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6416106",
  null
  
)

export default component.exports